import { render } from "./HeroiconsOutlineArrowCircleUp.vue?vue&type=template&id=e685f75e"
const script = {}

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowCircleUp.vue"]])

export default __exports__